import { CadJsonPicker } from '@/components/cad-import/CadJsonPicker';
import { CadMateriaalPreview } from '@/components/cad-import/CadMateriaalPreview';
import type { MateriaalFaseControls } from '@/hooks/useMateriaalFaseControls';

interface MateriaalCadModalsProps {
  controls: MateriaalFaseControls;
  projectId: number;
  /** Called after a successful CAD import (e.g. to refresh fase mapping). */
  onSuccess?: () => void;
}

/**
 * Renders the CAD import flow (JSON picker → materiaal preview) driven entirely
 * by the shared hook's `cad` state. Lets every consumer (MateriaalTab + the
 * dashboard section) render the CAD modals without duplicating the JSX.
 *
 * Two stages, matching the original MateriaalTab:
 *   1. target set, no payload  → CadJsonPicker
 *   2. target set, payload set → CadMateriaalPreview
 */
export function MateriaalCadModals({ controls, projectId, onSuccess }: MateriaalCadModalsProps) {
  const { target, payload, setPayload, close } = controls.cad;

  if (!target) return null;

  if (!payload) {
    return (
      <CadJsonPicker
        projectId={projectId}
        title="CAD JSON kiezen voor materiaal"
        onSelect={(p) => setPayload(p)}
        onClose={close}
      />
    );
  }

  return (
    <CadMateriaalPreview
      projectId={projectId}
      taskId={target.taskId}
      faseName={target.taskName}
      payload={payload}
      onClose={close}
      onSuccess={() => onSuccess?.()}
    />
  );
}
